import { render, staticRenderFns } from "./RefundPageTab.vue?vue&type=template&id=0ef066a8"
import script from "./RefundPageTab.vue?vue&type=script&lang=js"
export * from "./RefundPageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports